import { useRef } from "react";

type NeedHelpDropdownProps = {
  className?: string;
  /** Render the trigger as a small icon button instead of the "Need Help?" text label. */
  iconOnly?: boolean;
};

export const NeedHelpDropdown = ({
  className = "",
  iconOnly = false,
}: NeedHelpDropdownProps) => {
  const detailsRef = useRef<HTMLDetailsElement>(null);
  const closeDropdown = () => {
    detailsRef.current?.removeAttribute("open");
  };

  return (
    <div className={`flex justify-end ${className}`}>
      <details ref={detailsRef} className="relative group">
        {iconOnly ? (
          <summary
            className="list-none cursor-pointer flex size-10 shrink-0 items-center justify-center rounded-full border border-stroke bg-white transition-all duration-300 hover:scale-105 hover:bg-off-white"
            aria-label="Call or email us"
          >
            <svg
              className="w-5 h-5 text-primary-button"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <path
                d="M3 5.5A2.5 2.5 0 015.5 3h1.379a1 1 0 01.949.684l1.19 3.57a1 1 0 01-.502 1.21l-1.653.827a11.06 11.06 0 006.346 6.346l.827-1.653a1 1 0 011.21-.502l3.57 1.19a1 1 0 01.684.949V18.5A2.5 2.5 0 0117 21h-1C8.82 21 3 15.18 3 8V5.5z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </summary>
        ) : (
          <summary className="list-none cursor-pointer flex flex-row items-center gap-x-1 font-clash-display text-md font-semibold text-primary-button hover:opacity-90">
            Need Help?
            <svg
              className="w-5 h-5 shrink-0 rotate-0 group-open:rotate-180 transition-transform duration-300 ease-in-out text-primary-button"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <path
                d="M8 10L12 14L16 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </summary>
        )}
        <div className="absolute right-0 mt-2 min-w-[260px] rounded-md border border-stroke bg-white p-2 shadow-sm z-20 flex flex-col">
          <a
            href="mailto:ehubsupport@pencom.gov.ng"
            onClick={closeDropdown}
            className="flex items-center gap-x-3 px-3 py-2 rounded-md font-clash-display text-sm text-medium-dark-grey hover:bg-off-white transition-colors"
          >
            <img
              src="/assets/icons/mail.svg"
              alt=""
              className="w-4 h-4 shrink-0"
            />
            ehubsupport@pencom.gov.ng
          </a>
          <a
            href="tel:+2342094603955"
            onClick={closeDropdown}
            className="flex items-center gap-x-3 px-3 py-2 rounded-md font-clash-display text-sm text-medium-dark-grey hover:bg-off-white transition-colors"
          >
            <img
              src="/assets/icons/phone.svg"
              alt=""
              className="w-4 h-4 shrink-0"
            />
            02094603955
          </a>
        </div>
      </details>
    </div>
  );
};
